// extracted by mini-css-extract-plugin
export default {"sultanhaniTradeNetwork":"sultanhani-trade-network_sultanhaniTradeNetwork__1ZNDO","landmarkIcon":"sultanhani-trade-network_landmarkIcon__0h80c"};